import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobiThemeComponent } from './mobi-theme/mobi-theme.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleMobi } from '../material/material.module';
import { SharedModule,AppPermissionsPipe } from 'shared-library';



@NgModule({
  declarations: [
    MobiThemeComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    FormsModule,  
    ReactiveFormsModule,
    SharedModule,
    AppPermissionsPipe
  ],
  exports: [
    MobiThemeComponent
  ]
})
export class MobiThemeModule { }
